export default {
  showAlarms: 'Show alarms',
  showStages: 'Show stages',
  showMarkers: 'Show markers',
  showHoverPoints: 'Show hovered points',
};
